import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TranslateModule} from '@ngx-translate/core';

import {SidebarHeaderComponent} from './sidebar-header.component';

@NgModule({
  imports: [CommonModule, TranslateModule, MatIconModule, MatTooltipModule],
  declarations: [SidebarHeaderComponent],
  exports: [SidebarHeaderComponent]
})
export class SidebarHeaderModule {}
